import { FaBullseye } from "react-icons/fa";
import HeroSection from "../../../../../ReusableComponent/HeroSection"

function PlacementHeroSection() {
  const stats = [
    { value: "94%", label: "Success Rate" },
    { value: "500+", label: "Companies" },
    { value: "50K+", label: "Students Placed" },
    { value: "4.9", label: "Rating" },
  ];

  return (
    <HeroSection
      title="Placement Preparation"
      subtitle="Get placed at your dream company with our comprehensive preparation program"
      icon={<FaBullseye />}
      stats={stats}
    />
  );
}

export default PlacementHeroSection;